import React from "react";

type QuantitySelectorProps = {
    quantity: number;
    setQuantity: (quantity: number) => void;
    className?: string;
    symbolHeight?: string;
    buttonStyle?: string;
    boxWidth?: string;
    isCheckout?: boolean;
};

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
    quantity,
    setQuantity,
    className = "px-4 w-[84px] h-12",
    symbolHeight = '24',
    buttonStyle = 'right-[6px] top-0 pr-[6px]',
    boxWidth = 'w-fit',
    isCheckout = false,
}) => {
    const handleMinus = () => {
        if (quantity - 1 === 0) {
            //alert?
        } else {
            setQuantity(canonicalValue(quantity - 1));
        }
    };

    const handlePlus = () => {
        setQuantity(canonicalValue(quantity + 1));
    };

    const handleChange = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9]/gim, "");
        setQuantity(canonicalValue(Number(value)));
    };

    const canonicalValue = (value) => {
        if (value < 0) {
            value = 1;
        }
        if (value > 99) {
            value = 99;
        }
        return value;
    }

    return (
        <>
            {isCheckout && (
                <div className={`${className} flex flex-row text-sm font-semibold`}>
                    <button onClick={handleMinus} className="w-[30px] h-[30px] border-l border-y border-[#d3d4d5] rounded-l-full">
                        <svg className="mx-auto" height="12px" width="12px" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 384 512">
                            <path d="M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"></path>
                        </svg>
                    </button>
                    <input
                        className={`${boxWidth} w-[30px] h-[30px] border border-[#d3d4d5] text-center bg-transparent`}
                        type="text"
                        value={quantity}
                        onChange={handleChange}
                        aria-label="quantity input"
                    />
                    <button onClick={handlePlus} className="w-[30px] h-[30px] border-r border-y border-[#d3d4d5] rounded-r-full">
                        <svg className="mx-auto" height="12px" width="12px" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 384 512">
                            <path d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"></path>
                        </svg>
                    </button>

                    {/* <div className={`${buttonStyle} flex flex-col-reverse items-center pl-[6px] border-l border-[#d3d4d5] bg-white`}>
                        <PlusButton onClick={handlePlus} symbolHeight={symbolHeight} />
                    </div> */}
                </div>
            ) || (
                    <div className={`${boxWidth} flex flex-row border-[#e2e2e2] border`}>

                        <input
                            className={`${className} text-base-16 bg-white`}
                            type="text"
                            value={quantity}
                            onChange={handleChange}
                            aria-label="quantity input"
                        />
                        <div className={`${buttonStyle} flex flex-col-reverse items-center pl-[6px] border-l border-[#e2e2e2] bg-white`}>
                            <MinusButton onClick={handleMinus} symbolHeight={symbolHeight} />
                            <PlusButton onClick={handlePlus} symbolHeight={symbolHeight} />
                        </div>
                    </div>
                )}
        </>
    );
};

type ButtonType = {
    onClick: () => void;
    symbolHeight: string;
};

const MinusButton: React.FC<ButtonType> = ({ onClick, symbolHeight }) => {
    return (
        <button aria-label="Remove one product" onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width={symbolHeight} height={symbolHeight} viewBox="0 0 24 24" fill="none">
                <path d="M7 8L12 13L17 8" stroke="#2c2d33" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    );
};

const PlusButton: React.FC<ButtonType> = ({ onClick, symbolHeight }) => {
    return (
        <button aria-label="Add one product" onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width={symbolHeight} height={symbolHeight} viewBox="0 0 24 24" fill="none">
                <path d="M7 16L12 11L17 16" stroke="#2c2d33" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    );
};

export default QuantitySelector;
